import Store from '../../../../../../Store'
import sk from './images/sk.jpg'
import hu from './images/hu.jpg'
import hr from './images/hr.png'
import lt from './images/lt.png'
import ro from './images/ro.png'
import cs from './images/cs.png'
import lv from './images/lv.png'
import bg from './images/bg.png'

export const mockImages = {
    sk,
    hu,
    hr,
    lt,
    ro,
    cs,
    lv,
    bg
}

export const getMockImage = () => {
    const short = Store.getUserPlatformLangShort();
    return mockImages[short]
}